import { useEffect, useState } from "react";
import Card from "./Card";

const Cards = ({ products }) => {

    const [orgID, setOrgID] = useState(0)    

    tangibleFields.event('valueChange', field => {
        if ( field.name === 'membersync-orgs-shop-org-selected' ) {
            // console.log('field.value : ', field.value)
            setOrgID(field.value.value ?? 0)
        }
    })

    const addToCart = async function(quantity, productID, cartOrgID, productType, variationQuantity, variationID, variationAddMore) {

        const url = restUrl + '/wp-json/membersync/licensing/v1/org/shop/add'
        const nonce = restNonce

        await fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                org_id: cartOrgID,
                quantity: quantity,
                product_id: productID,
                product_type: productType,
                variation_quantity: variationQuantity,
                variation_id: variationID,
                variation_add_more: variationAddMore
            }),
            headers:{
                'X-WP-Nonce': nonce,
                'Content-type': 'application/json'
            }
        }).then(resp => {
            return resp.json()
        })
        .then((json) => {
            // setProducts([...json.response])
            return true
        })
    }

    return (
        <div>
            {
                tangibleFields.render({
                    type: 'combo-box',
                    label: 'Current org selected',
                    name: 'membersync-orgs-shop-org-selected',
                    isAsync: true,
                    ajaxAction: 'get_orgs',
                })
            }
            {
                orgID === 0
                    ? 'No organization selected' 
                    : <div class='membersync-orgs-products-cards'>
                        <Card
                            data={products}
                            addToCart={ async (quantity, productID, productType, variationQuantity, currentVariationID, variationAddMore) => {
                                return await addToCart( quantity, productID, orgID, productType, variationQuantity, currentVariationID, variationAddMore )
                            }}
                        />
                      </div>
            }
        </div>
    );
};

export default Cards;